import React, { useState } from "react";
import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { GRAVITA, useAvvisiAttivi } from "@/contexts/AvvisiContext";

const STILE = {
  info: { icona: "text-sky-600 bg-sky-50 border-sky-200", punto: "bg-sky-500", nome: "Informazione" },
  segnalazione: { icona: "text-orange-600 bg-orange-50 border-orange-200", punto: "bg-orange-500", nome: "Segnalazione" },
  critico: { icona: "text-rose-600 bg-rose-50 border-rose-200", punto: "bg-rose-600", nome: "Critico" },
};

// Sprint UI-GLOBALE — icona in alto: grigia senza avvisi, colorata secondo la gravità più alta.
export default function CentroAvvisi() {
  const avvisi = useAvvisiAttivi();
  const [open, setOpen] = useState(false);
  const ordinati = [...avvisi].sort((a, b) => (GRAVITA[b.livello] || 0) - (GRAVITA[a.livello] || 0));
  const top = ordinati[0]?.livello;
  const cls = top ? STILE[top].icona : "text-slate-400 bg-white border-slate-200";
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" aria-label={`Centro avvisi: ${avvisi.length} avvisi`} title="Centro avvisi"
          className={`relative h-9 w-9 inline-flex items-center justify-center rounded-md border transition-colors ${cls}`}
          data-testid="centro-avvisi-btn" data-livello={top || "nessuno"}>
          <Info className="h-[18px] w-[18px]" />
          {avvisi.length > 0 && (
            <span className={`absolute -top-1 -right-1 min-w-[16px] h-4 px-1 rounded-full text-[10px] leading-4 text-white ${STILE[top].punto}`}
              data-testid="centro-avvisi-count">{avvisi.length}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0" data-testid="centro-avvisi-panel">
        <div className="px-4 py-2.5 border-b text-xs uppercase tracking-wide text-slate-500">Avvisi su questa pagina</div>
        {ordinati.length === 0 ? (
          <div className="px-4 py-6 text-sm text-slate-500" data-testid="centro-avvisi-vuoto">Nessun avviso.</div>
        ) : (
          <ul className="max-h-96 overflow-y-auto divide-y">
            {ordinati.map((a) => (
              <li key={a.id} className="px-4 py-3 flex gap-2.5" data-testid={`centro-avviso-${a.id}`}>
                <span className={`mt-1.5 h-2 w-2 rounded-full shrink-0 ${STILE[a.livello]?.punto}`} title={STILE[a.livello]?.nome} />
                <div className="text-sm text-slate-800 min-w-0">
                  <div>{a.testo}</div>
                  {a.link && (
                    <button type="button" className="mt-1 text-blue-700 underline underline-offset-2 text-[13px]"
                      onClick={() => { setOpen(false); a.link.onClick(); }} data-testid={`centro-avviso-link-${a.id}`}>
                      {a.link.label}
                    </button>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
      </PopoverContent>
    </Popover>
  );
}
